import { useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PageHeader, Panel, GoldButton, Empty } from "@/components/common";

// Generic catalog page used by Operatori and Trattamenti
export default function CatalogPage({ resource, overline, title, singular, fields, blank, renderCard, testPrefix, items, reload }) {
  const [dlg, setDlg] = useState(null);
  const save = async () => {
    const f = dlg.f;
    if (!String(f.name || "").trim()) return toast.error("Il nome è obbligatorio");
    const body = Object.fromEntries(Object.keys(blank).map((k) => [k, typeof blank[k] === "number" ? Number(f[k]) || 0 : f[k]]));
    try {
      if (dlg.id) await api.put(`/${resource}/${dlg.id}`, body);
      else await api.post(`/${resource}`, body);
      toast.success(`${singular} salvato`);
      setDlg(null);
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (id) => {
    if (!window.confirm(`Eliminare questo ${singular.toLowerCase()}?`)) return;
    await api.delete(`/${resource}/${id}`);
    reload();
  };

  return (
    <div data-testid={`${testPrefix}-page`}>
      <PageHeader overline={overline} title={title}>
        <GoldButton onClick={() => setDlg({ f: { ...blank } })} data-testid={`${testPrefix}-add-button`}><Plus className="h-4 w-4" /> Aggiungi {singular.toLowerCase()}</GoldButton>
      </PageHeader>
      {items.length === 0 && <Empty testId={`${testPrefix}-empty`}>Nessun elemento. Aggiungine uno con il pulsante in alto.</Empty>}
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it) => (
          <Panel key={it.id} className="group p-6 fade-up transition-transform duration-300 hover:-translate-y-0.5" data-testid={`${testPrefix}-card-${it.id}`}>
            {renderCard(it)}
            <div className="mt-5 flex gap-3 border-t border-[#E8E1D7] pt-4">
              <button onClick={() => setDlg({ id: it.id, f: { ...it } })} className="flex items-center gap-1 text-sm text-[#6E675F] hover:text-[#C5A059]" data-testid={`${testPrefix}-edit-${it.id}`}><Pencil className="h-3.5 w-3.5" /> Modifica</button>
              <button onClick={() => del(it.id)} className="flex items-center gap-1 text-sm text-[#6E675F] hover:text-red-700" data-testid={`${testPrefix}-delete-${it.id}`}><Trash2 className="h-3.5 w-3.5" /> Elimina</button>
            </div>
          </Panel>
        ))}
      </div>
      <Dialog open={!!dlg} onOpenChange={(o) => !o && setDlg(null)}>
        <DialogContent className="bg-[#FDFBF7] border-[#E8E1D7] max-w-lg" data-testid={`${testPrefix}-dialog`}>
          <DialogHeader><DialogTitle className="font-serif text-3xl font-normal">{dlg?.id ? "Modifica" : "Nuovo"} {singular.toLowerCase()}</DialogTitle></DialogHeader>
          {dlg && <div className="grid gap-4 sm:grid-cols-2">{fields(dlg.f, (f) => setDlg({ ...dlg, f }))}</div>}
          <div className="flex justify-end"><GoldButton onClick={save} data-testid={`${testPrefix}-save-button`}>Salva</GoldButton></div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
